export let lineItemError;
(function (lineItemError) {
  lineItemError["ORDER_TOTAL_BELOW_MIN_OPTIONAL"] = "ORDER_TOTAL_BELOW_MIN_OPTIONAL";
  lineItemError["ORDER_TOTAL_BELOW_MIN"] = "ORDER_TOTAL_BELOW_MIN";
  lineItemError["ORDER_TOTAL_TOTAL_ABOVE_MAX"] = "ORDER_TOTAL_TOTAL_ABOVE_MAX";
  lineItemError["RECURRING_TOTAL_BELOW_MIN"] = "RECURRING_TOTAL_BELOW_MIN";
  lineItemError["RECURRING_TOTAL_ABOVE_MAX"] = "RECURRING_TOTAL_ABOVE_MAX";
  lineItemError["FUTURE_ITEM_EXPIRED"] = "FUTURE_ITEM_EXPIRED";
})(lineItemError || (lineItemError = {}));